import { SET_DATES } from '../../../../actions/chart';

export default (state = null, action) => {
  switch (action.type) {
    case SET_DATES:
      return action.payload.from;
    default:
      return state;
  }
};

export const getFromDate = state => state;